<template>
  <ArticleBodyStyles class="ArticleBodyContent">
    <PortableText :value="blocks" :components="serializerComponents" />
  </ArticleBodyStyles>
</template>

<script setup>
import { h } from 'vue'

import ArticleBodyStyles from './ArticleBodyStyles.vue';
import BodyContentImage from './BodyContentImage.vue'

import CtaButton from '../../button-styles/CtaButton.vue'
import CtaLink from '../../button-styles/CtaLink.vue'

const { blocks, headingIds } = defineProps({
  blocks: {
    type: Array,
  },
  headingIds: {
    type: Object,
    required: false,
  },
})

function makeHeadingComponent(tag) {
  return ({ value }, { slots }) => h(tag, { id: headingIds?.[value._key] }, slots.default?.())
}

function ctaComponent({ value }) {
  const { text, action } = value
  const isLink = action?.startsWith('#') || action?.includes('/')
  return h(isLink ? CtaLink : CtaButton, { class: '--dark-blue', text, action })
}

const serializerComponents = {
  block: {
    h1: makeHeadingComponent('h1'),
    h2: makeHeadingComponent('h2'),
    h3: makeHeadingComponent('h3'),
    h4: makeHeadingComponent('h4'),
    h5: makeHeadingComponent('h5'),
    h6: makeHeadingComponent('h6'),
  },
  types: {
    cta: ctaComponent,
    image: BodyContentImage,
  },
  marks: {
    link: ({ text, value }) => h('a', { href: value.href, target: value.blank && '_blank' }, text)
  },
}
</script>
